import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { DestinacaoReserva2008Component } from '../destinacao-reserva-2008/destinacao-reserva-2008.component';
import { DestinacaoReserva2009Component } from '../destinacao-reserva-2009/destinacao-reserva-2009.component';
import { DestinacaoReservaComplet2008Component } from '../destinacao-reserva-complet-2008/destinacao-reserva-complet-2008.component';
import { DestinacaoReservaMenorIgual2012Component } from '../destinacao-reserva-menor-igual-2012/destinacao-reserva-menor-igual-2012.component';

const destinacaoReservaRoutes = [
    { path: 'destinacaoR2008', component: DestinacaoReserva2008Component },
    { path: 'destinacaoR2008/complemento', component: DestinacaoReservaComplet2008Component },
    { path: 'destinacaoR2009', component: DestinacaoReserva2009Component },
    { path: 'destinacaoRMI2012', component: DestinacaoReservaMenorIgual2012Component }
];

@NgModule({
    imports: [RouterModule.forChild(destinacaoReservaRoutes)],
    exports: [RouterModule]
})
export class DestinacaoReservaRoutingModule {


}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/financeiro/destinacao-reserva/router/destinacao-reserva.router.ts